<template>
  <span>
    <b-button
      v-if="!onlyIcon"
      :block="block"
      :disabled="disabled || loading"
      :type="type"
      v-on="$listeners"
      :variant="variant"
      :size="size"
      :class="['btn  btn-label', buttonClass]"
    >
      <i class="label-icon" :class="icon" v-if="!loading"></i>
      <span v-else class="label-icon">
        <i class="bx bx-loader bx-spin font-size-16 align-middle"></i>
      </span>

      <slot></slot>
    </b-button>
    <b-button
      v-if="onlyIcon"
      v-b-tooltip.hover
      :title="title || $t('common.save')"
      :disabled="disabled || loading"
      :type="type"
      v-on="$listeners"
      :variant="variant"
      :size="size"
      :class="['btn', buttonClass]"
    >
      <i class="label-icon" :class="icon" v-if="!loading"></i>
      <span v-else class="label-icon">
        <i class="bx bx-loader bx-spin font-size-16 align-middle"></i>
      </span>
    </b-button>
  </span>
</template>

<script>
export default {
  props: {
    block: {
      type: Boolean,
      required: false,
    },
    size: {
      type: String,
      required: false,
      default: "sm",
    },
    variant: {
      type: String,
      required: false,
      default: "primary",
    },
    buttonClass: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
      default: undefined,
    },
    onlyIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: undefined,
    },
    title: {
      type: String,
      required: false,
    },
  },
  methods: {},
};
</script>

<style></style>
